import { nl } from './nl';
import { en } from './en';

export const translations = {
  nl,
  en
};

export const defaultLanguage = 'nl';
export const supportedLanguages = ['nl', 'en'];
